var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('headerMode'),_c('div',{staticClass:"main-page"},[_c('router-view')],1),_c('footerMode'),_c('floatNav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }